import { connect } from 'react-redux';
import Global from '../../../store/global-selectors';
import { LabelBatchStatusModal } from './index';
import { LabelBatchValidating } from './validating';
import { LabelBatchErrorOrWarnContainer } from './error-warn/open-batch.container';
import { LabelBatchLoading } from './loading';
import { LabelBatchCostReview } from './cost-review/open-batch.container';
import { LabelBatchProcessingModalContainer } from './processing/modal-container';
import { LabelBatchStatusStep } from '../../../enums/label-batch-status-step';
import { LabelBatchSubscriptionLimitError } from './subscription-limit';
import { LabelBatchNoOrdersIncluded } from './no-orders-included';

const stepToComponentMap = {
  [LabelBatchStatusStep.Validating.ordinal]: LabelBatchValidating,
  [LabelBatchStatusStep.ErrorOrWarning.ordinal]: LabelBatchErrorOrWarnContainer,
  [LabelBatchStatusStep.Loading.ordinal]: LabelBatchLoading,
  [LabelBatchStatusStep.CostReview.ordinal]: LabelBatchCostReview,
  [LabelBatchStatusStep.Processing.ordinal]: LabelBatchProcessingModalContainer,
  [LabelBatchStatusStep.SubscriptionLimitError.ordinal]: LabelBatchSubscriptionLimitError,
  [LabelBatchStatusStep.NoOrdersIncluded.ordinal]: LabelBatchNoOrdersIncluded,
};

const mapStateToProps = (state, ownProps) => {
  const { fulfillmentPlanSetId } = ownProps;
  const stringFulfillmentPlanSetId = fulfillmentPlanSetId.toString();
  const batchJobEntity =
    Global.selectEntitiesBatchByFulfillmentPlanSetId(state, {
      fulfillmentPlanSetId,
    }) || {};
  const batchIdsByParentBatchId = Global.selectBatchesPurchaseBatchIdsByParentBatchId(state, {
    batchId: fulfillmentPlanSetId,
  });
  const stringBatchIdsByParentBatchId = batchIdsByParentBatchId.map((id) => id.toString());
  const batchIds = batchIdsByParentBatchId.length > 0 ? stringBatchIdsByParentBatchId : [stringFulfillmentPlanSetId];
  const { step = LabelBatchStatusStep.Validating.ordinal, batchName, totalLabels, error } = batchJobEntity;

  return {
    step,
    StepComponent: stepToComponentMap[step],
    batchId: stringFulfillmentPlanSetId,
    batchIds,
    batchName,
    totalLabels,
    error,
  };
};

export const LabelBatchStatusContainer = connect(mapStateToProps)(LabelBatchStatusModal);
